import React from "react";
import ProfileStatsBlock from "../../../../components/profileStatsBlock/profileStatsBlock";
import { useSelector } from "react-redux";

const TopPerformers = ({ index, topPerformer }) => {
  const topPerformers = useSelector((state) => state.attendance.topPerformers);

  return <ProfileStatsBlock data={topPerformers} index={index} topPerformer={topPerformer} />;
};

export default TopPerformers;
